import { render, staticRenderFns } from "./SimpleInBetween.vue?vue&type=template&id=01aafe65&"
import script from "./SimpleInBetween.vue?vue&type=script&lang=ts&"
export * from "./SimpleInBetween.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports